import { useState } from "react";

import { useMount } from "app/custom-hooks/useMount";

type ScrollbarType = "overlay" | "classic";

const detectScrollbarType = (): ScrollbarType => {
    const scrollDiv = document.createElement("div");

    scrollDiv.style.width = "100px";
    scrollDiv.style.height = "100px";
    scrollDiv.style.overflow = "scroll";
    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.visibility = "hidden";

    document.body.appendChild(scrollDiv);

    const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return scrollbarWidth === 0 ? "overlay" : "classic";
};

export function useScrollbarType(): ScrollbarType | undefined {
    const [type, setType] = useState<ScrollbarType>();

    useMount(() => {
        const scrollbarType = detectScrollbarType();

        setType(scrollbarType);
    });

    return type;
}
